;(function ($) {

  $(document).ready(function () {
    $('body').on('click', '.show-hide-button', showHideToggle);
    initShowHideToggle();
  });

  /**
   * Show/Hide Accordion Toggle.
   */
  function showHideToggle() {
    // console.log('showHideToggle');
    let $this = $(this),
      content = $this.parents('.show-hide-container').find('.show-hide-content');

    if (content.hasClass('show')) {
      // console.log('close toggle');
      content.removeClass('show');
      $this.removeClass('up-arrow');
      content.attr('aria-hidden', true);
      $this.attr('aria-expanded', false);
    } else {
      // console.log('open toggle');
      content.addClass('show');
      $this.addClass('up-arrow');
      content.attr('aria-hidden', false);
      $this.attr('aria-expanded', true);
    }
  }

  /**
   * Init the Show/Hide Accordions, Covers NO-JS
   */
  function initShowHideToggle() {
    let showHideContent = $('.show-hide-content'),
      showHideButton = $('.show-hide-button');

    if(showHideContent.hasClass('load-open')) {
      return;
    }

    if (showHideContent) {
      showHideContent.removeClass('show');
      showHideContent.attr('aria-hidden', true);
    }
    if (showHideButton) {
      showHideButton.removeClass('up-arrow');
    }
  }

})(jQuery);
